module.exports = __webpack_public_path__ + "res/tic_tac_toe.92caafeb5156a747cd8d01299cc6edc1.webp";